import Vue from 'vue'
import VueRouter from 'vue-router'
import ThreadList from './ThreadList.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/all',
    },
    {
        path: '/all/:page?',
        name: '0',
        component: ThreadList,
    },
    {
        path: '/discuss/:page?',
        name: '1',
        component: ThreadList,
    },
    {
        path: '/water/:page?',
        name: '2',
        component: ThreadList,
    },
]

const router = new VueRouter({
    routes
})

router.beforeEach(async (to, from, next) => {
    if (to.name) { // 首次进入不处理
        if (!to.params.page) to.params.page = 1;
    }
    next();
})

export default router
